import { render, staticRenderFns } from "./PresentationPanel.vue?vue&type=template&id=61023ed8&scoped=true"
import script from "./PresentationPanel.vue?vue&type=script&lang=ts"
export * from "./PresentationPanel.vue?vue&type=script&lang=ts"
import style0 from "./PresentationPanel.vue?vue&type=style&index=0&id=61023ed8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61023ed8",
  null
  
)

export default component.exports